import React from 'react'
import { FormControl, Button, Table, Row, Col, Tabs, Tab, Checkbox } from 'react-bootstrap'
import { getParams, getMonth, makeUniqueKey, end_point, formatSessionDateLabel, sortProgramSessions } from './helper'
import HamburgerNavbar from './hamburgerNavbar'
import AthleteProfile from './athleteProfile'
import AthleteMessagesPanel from './AthleteMessagesPanel'

var $ = require('jquery')

class ParentPortal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current_user: null,
      athletes: null,
      selected_athlete_id: null,
      token: getParams().jwt,
      account_holder_first_name: '',
      account_holder_last_name: '',
      account_holder_email: '',
      account_holder_phone: '',
      emergency_contact_first_name: '',
      emergency_contact_last_name: '',
      emergency_contact_email: '',
      emergency_contact_phone: '',
      marketing_opt_out: false,
      programs: null,
      program_map: [],
      selected_program_id: null,
      selected_registration_key: null,
      selected_registration_conversation_key: null,
      organization_id: this.props.organization_id,
      organization_name: localStorage.getItem("organization_name"),
      organization_logo: localStorage.getItem("organization_logo"),
      haveData: false,
      organization_endpoint: `${end_point('organizations')}/organizations`,
      user_endpoint: `${end_point('users')}/users`,
      portal_endpoint: `${end_point()}/parentPortal`,
      status_index: 0,
      activeTab: this.props.standaloneTab || 'registrations',
      registrations: [],
      initial_account_holder_snapshot: null
    };
  }

  componentDidMount() {
    this.loadPage()
  }

  loadPage = () => {
    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id
      },
      method: "GET",
      dataType: "json",
      url: this.state.organization_endpoint,
    }).then(this.organizationGetHandler);

    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id,
        "current_user_needed": true
      },
      method: "GET",
      dataType: "json",
      url: this.state.user_endpoint,
    }).then((data) => {
      const current_user = data && data.message && data.message[0] ? data.message[0] : null
      const initial_account_holder_snapshot = current_user ? {
        first_name: current_user.first_name || '',
        last_name: current_user.last_name || '',
        email: current_user.email || '',
        marketing_opt_out: !!current_user.marketing_opt_out,
        extras: {
          phone: current_user && current_user.extras ? current_user.extras.phone || '' : '',
          secondary_parent: {
            first_name: current_user && current_user.extras && current_user.extras.secondary_parent ? current_user.extras.secondary_parent.first_name || '' : '',
            last_name: current_user && current_user.extras && current_user.extras.secondary_parent ? current_user.extras.secondary_parent.last_name || '' : '',
            email: current_user && current_user.extras && current_user.extras.secondary_parent ? current_user.extras.secondary_parent.email || '' : '',
            phone: current_user && current_user.extras && current_user.extras.secondary_parent ? current_user.extras.secondary_parent.phone || '' : ''
          }
        }
      } : null
      this.setState({
        current_user,
        account_holder_first_name: current_user ? current_user.first_name : '',
        account_holder_last_name: current_user ? current_user.last_name : '',
        account_holder_email: current_user ? current_user.email : '',
        account_holder_phone: current_user && current_user.extras ? current_user.extras.phone || '' : '',
        emergency_contact_first_name: current_user && current_user.extras && current_user.extras.secondary_parent ? current_user.extras.secondary_parent.first_name || '' : '',
        emergency_contact_last_name: current_user && current_user.extras && current_user.extras.secondary_parent ? current_user.extras.secondary_parent.last_name || '' : '',
        emergency_contact_email: current_user && current_user.extras && current_user.extras.secondary_parent ? current_user.extras.secondary_parent.email || '' : '',
        emergency_contact_phone: current_user && current_user.extras && current_user.extras.secondary_parent ? current_user.extras.secondary_parent.phone || '' : '',
        marketing_opt_out: current_user ? !!current_user.marketing_opt_out : false,
        initial_account_holder_snapshot
      })
    });

    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id,
      },
      method: "GET",
      dataType: "json",
      url: this.state.portal_endpoint
    }).then(data => { this.portalGetHandler(data.message); });
  }

  organizationGetHandler = (resp) => {
    localStorage.setItem("organization_name", resp.name);
    localStorage.setItem("organization_logo", resp.logo);

    this.setState({
      organization_name: resp.name,
      organization_logo: resp.logo + "?" + Math.floor((Math.random() * 1000) + 1)
    });
  }

  portalGetHandler = (resp) => {
    const athletes = Array.isArray(resp.athletes)
      ? resp.athletes.filter((athlete) => !(athlete && athlete.extras && athlete.extras.parent_portal_hidden))
      : []
    const programMap = Array.isArray(resp.programs) ? resp.programs : []
    const registrations = this.getRegistrations(athletes, programMap)
    const initialRegistration = registrations[0] || null

    this.setState({
      haveData: true,
      selected_athlete_id: initialRegistration ? initialRegistration.athlete_id : null,
      selected_program_id: initialRegistration ? initialRegistration.program_id : null,
      selected_registration_key: initialRegistration ? initialRegistration.key : null,
      selected_registration_conversation_key: null,
      athletes,
      programs: registrations,
      program_map: programMap,
      registrations,
      status_index: initialRegistration ? initialRegistration.status_index : 0
    })
  }

  handleHideAthleteFromPortal = (athleteId) => {
    this.handleUpdateSubmit({ extras: { parent_portal_hidden: true } }, athleteId, 'athlete_spinner')
  }

  getAthleteLabel = (athlete = {}) => {
    return `${athlete.first_name || ''} ${athlete.last_name || ''}`.trim() || 'Athlete'
  }

  handleChange = (field, e) => {
    this.setState({
      [field]: e.target.value,
      account_holder_confirm: false
    })
  }

  handleMarketingChange = () => {
    this.setState((prevState) => ({
      marketing_opt_out: !prevState.marketing_opt_out,
      account_holder_confirm: false,
    }))
  }

  getAccountHolderSnapshot = () => ({
    first_name: this.state.account_holder_first_name || '',
    last_name: this.state.account_holder_last_name || '',
    email: this.state.account_holder_email || '',
    marketing_opt_out: !!this.state.marketing_opt_out,
    extras: {
      phone: this.state.account_holder_phone || '',
      secondary_parent: {
        first_name: this.state.emergency_contact_first_name || '',
        last_name: this.state.emergency_contact_last_name || '',
        email: this.state.emergency_contact_email || '',
        phone: this.state.emergency_contact_phone || ''
      }
    }
  })

  isAccountHolderDirty = () => {
    return JSON.stringify(this.getAccountHolderSnapshot()) !== JSON.stringify(this.state.initial_account_holder_snapshot || {})
  }

  getAccountHolderFormFields = () => {
    return {
      "first_name": this.state.account_holder_first_name,
      "last_name": this.state.account_holder_last_name,
      "email": this.state.account_holder_email,
      "marketing_opt_out": this.state.marketing_opt_out,
      "extras": {
        "phone": this.state.account_holder_phone,
        "secondary_parent": {
          "first_name": this.state.emergency_contact_first_name,
          "last_name": this.state.emergency_contact_last_name,
          "email": this.state.emergency_contact_email,
          "phone": this.state.emergency_contact_phone
        }
      }
    }
  }

  handleAccountHolderSubmit = () => {
    const accountHolderEmail = (this.state.account_holder_email || '').toLowerCase()
    const secondaryEmail = (this.state.emergency_contact_email || '').toLowerCase()

    if (accountHolderEmail && accountHolderEmail === secondaryEmail) {
      alert("Secondary email cannot be same as parent email");
      return
    }

    const change = this.getAccountHolderFormFields()
    this.handleUpdateSubmit(change, this.state.current_user ? this.state.current_user._id : null, 'account_holder_spinner')
  }

  handleUpdateSubmit = (change, id, spinner) => {
    if (!id) {
      alert("Unable to update the profile at the moment, please contact support")
      return
    }

    this.setState({ [spinner]: true })
    const familyMembers = Array.isArray(this.state.athletes) ? this.state.athletes : []
    const match = familyMembers.find((athlete) => (athlete.email || '').toLowerCase() === (this.state.account_holder_email || '').toLowerCase())

    if (match && spinner === 'account_holder_spinner') {
      alert("Athlete email cannot be same as parent email");
      this.setState({ [spinner]: false })
      return
    }

    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": localStorage.getItem("organization_id")
      },
      method: "PATCH",
      contentType: 'application/json',
      data: JSON.stringify({
        "id": id,
        "change": change
      }),
      url: this.state.user_endpoint,
      success: (data) => {
        if (data.errorMessage) {
          alert(data.errorMessage);
          this.setState({ [spinner]: false })
        } else {
          this.loadPage()
        }
      },
      error: () => {
        alert("Unable to update the profile at the moment, please contact support")
        this.setState({ [spinner]: false })
      }
    })
  }

  getContactLabel = (user = {}) => {
    const firstName = user.first_name || ''
    const lastName = user.last_name || ''
    return `${firstName} ${lastName}`.trim() || 'Not provided'
  }

  handleTabSelect = (activeTab) => {
    if (activeTab) {
      this.setState({ activeTab })
    }
  }

  getRegistrations = (athletes = [], programMap = []) => {
    const programsById = Array.isArray(programMap)
      ? programMap.reduce((acc, program) => {
          if (program && program._id) {
            acc[program._id.toString()] = program
          }
          return acc
        }, {})
      : {}

    const registrations = []

    athletes.forEach((athlete) => {
      const athletePrograms = Array.isArray(athlete.programs) ? athlete.programs : []
      athletePrograms.forEach((program, index) => {
        const programId = program && program.id ? program.id.toString() : ''
        if (!programId) {
          return
        }

        const programDoc = programsById[programId] || {}
        const athleteLabel = this.getAthleteLabel(athlete)
        registrations.push({
          key: `${athlete._id}:${programId}`,
          athlete_id: athlete._id,
          athlete_name: athleteLabel,
          athlete_email: athlete.email || '',
          program_id: programId,
          program_name: program.name || programDoc.name || programDoc.group_name || 'Program',
          group_name: program.group_name || programDoc.group_name || programDoc.name || '',
          status: program.status || programDoc.status || '',
          start_date: program.start_date || programDoc.start_date || '',
          end_date: program.end_date || programDoc.end_date || '',
          ages: program.ages || programDoc.ages || '',
          division: program.division || programDoc.division || '',
          status_index: index,
        })
      })
    })

    return registrations.sort((left, right) => {
      const leftDate = left.start_date ? new Date(left.start_date).getTime() : 0
      const rightDate = right.start_date ? new Date(right.start_date).getTime() : 0
      if (rightDate !== leftDate) {
        return rightDate - leftDate
      }

      return `${left.program_name} ${left.athlete_name}`.localeCompare(`${right.program_name} ${right.athlete_name}`)
    })
  }

  handleRegistrationSelect = (selection) => {
    const selectedRegistration = (this.state.registrations || []).find((registration) => registration.key === selection.target.value)

    if (!selectedRegistration) {
      return
    }

    this.setState({
      selected_registration_key: selectedRegistration.key,
      selected_program_id: selectedRegistration.program_id,
      selected_athlete_id: selectedRegistration.athlete_id,
      status_index: selectedRegistration.status_index || 0,
      selected_registration_conversation_key: null,
    })
  }

  getTeamOptions = () => {
    const teams = {}
    ;(this.state.registrations || []).forEach((registration) => {
      const programId = registration.program_id && registration.program_id.toString()
      if (!programId || teams[programId]) {
        return
      }
      teams[programId] = {
        program_id: programId,
        registration_key: registration.key,
        program_name: registration.program_name,
      }
    })
    return Object.values(teams)
  }

  renderTeamSelector = () => {
    const teamOptions = this.getTeamOptions()
    const selectedRegistration = (this.state.registrations || []).find((registration) => registration.key === this.state.selected_registration_key) || null
    if (!teamOptions.length) {
      return null
    }
    return (
      <div className="parent-team-selector">
        <label htmlFor="selected_team">My teams</label>
        <FormControl
          className="parent-team-selector-control"
          id="selected_team"
          componentClass="select"
          value={selectedRegistration ? selectedRegistration.key : teamOptions[0].registration_key}
          onChange={this.handleRegistrationSelect}
        >
          {teamOptions.map((team) => (
            <option key={team.program_id} value={team.registration_key}>
              {team.program_name}
            </option>
          ))}
        </FormControl>
      </div>
    )
  }

  normalizeGroupName = (value) => String(value || '').trim().toLowerCase()

  getRegistrationConversations = (selectedRegistration) => {
    if (!selectedRegistration || !selectedRegistration.program_id) {
      return []
    }

    const programId = selectedRegistration.program_id.toString()
    const conversations = [{
      conversation_key: `${programId}:Participants`,
      group_name: 'Participants',
      label: 'Participants',
    }]
    const athlete = (Array.isArray(this.state.athletes) ? this.state.athletes : []).find((entry) => entry && entry._id && entry._id.toString() === selectedRegistration.athlete_id.toString())
    const teamGroups = athlete && Array.isArray(athlete.team_groups) ? athlete.team_groups : []

    teamGroups
      .filter((group) => group && group.program_id && group.program_id.toString() === programId)
      .forEach((group) => {
        const groupName = group.group_name || ''
        if (this.normalizeGroupName(groupName) === 'participants') {
          return
        }

        const conversation_key = group.conversation_key || `${programId}:${groupName}`
        if (!conversations.some((conversation) => conversation.conversation_key === conversation_key)) {
          conversations.push({
            conversation_key,
            group_name: groupName,
            label: groupName,
          })
        }
      })

    return conversations
  }

  formatDate = (dateString) => {
    if (!dateString) {
      return '-'
    }

    const date = new Date(dateString)
    if (Number.isNaN(date.getTime())) {
      return '-'
    }

    return `${getMonth(date.getMonth() + 1)} ${date.getDate()}, ${date.getFullYear()}`
  }

  displayAthlete = (athlete) => {
    if (!athlete) {
      return null
    }

    const extras = athlete.extras || {}

    return (
      <div className="white-text">
        <Table condensed responsive className="table-bordered">
          <thead>
            <tr>
              <th colSpan="2">Athlete Information</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>First Name:</td><td>{athlete.first_name}</td></tr>
            <tr><td>Last Name:</td><td>{athlete.last_name}</td></tr>
            <tr><td>Email:</td><td>{athlete.email}</td></tr>
            <tr><td>Phone Number:</td><td>{extras.phone}</td></tr>
            <tr><td>Date of Birth:</td><td>{extras.date_of_birth ? (new Date(extras.date_of_birth)).toLocaleDateString("en-US") : '-'}</td></tr>
            <tr><td>Gender:</td><td>{extras.gender}</td></tr>
            <tr><td>Address:</td><td>{extras.address}</td></tr>
            <tr><td>Postal Code:</td><td>{extras.postal_code}</td></tr>
            <tr><td>City:</td><td>{extras.city}</td></tr>
            <tr><td>Province:</td><td>{extras.province}</td></tr>
            <tr><td>Instagram:</td><td>{extras.social}</td></tr>
            <tr><td>Notes:</td><td>{extras.parent_notes}</td></tr>
          </tbody>
        </Table>
      </div>
    )
  }

  renderSummaryCard = (title, user, badgeLabel, emptyLabel = 'No details available.') => {
    const extras = user && user.extras ? user.extras : {}

    return (
      <div className="parent-family-card parent-family-card-summary">
        <div className="parent-family-card-header">
          <div>
            <div className="parent-family-name">{title}</div>
            <div className="parent-family-meta">{user && user.email ? user.email : emptyLabel}</div>
          </div>
          <div className="parent-family-badge">
            {badgeLabel}
          </div>
        </div>

        <div className="parent-family-details">
          <div><span>Name</span>{this.getContactLabel(user)}</div>
          <div><span>Phone</span>{extras.phone || '-'}</div>
          <div><span>Email</span>{user && user.email ? user.email : '-'}</div>
          <div><span>Marketing</span>{user && user.marketing_opt_out ? 'Opt Out' : 'Enabled'}</div>
        </div>
      </div>
    )
  }

  displayProgram = (program, includeSessions = true) => {
    if (!program) { return null }

    const temp_arr = Array.isArray(this.state.program_map) ? this.state.program_map.slice() : []
    const display = temp_arr.find((data) => {
      const programId = data && data._id ? data._id.toString() : ''
      return programId && programId === program.toString()
    }) || {}

    const enrolledUsers = Array.isArray(display.enrolled_users) ? display.enrolled_users : []
    const selectedAthleteId = this.state.selected_athlete_id ? this.state.selected_athlete_id.toString() : ''
    const temp_user_arr = enrolledUsers.filter((user) => {
      const userId = user && user._id ? user._id.toString() : ''
      return userId === selectedAthleteId && user.status !== 'unverified'
    })

    const status = (temp_user_arr[this.state.status_index] && temp_user_arr[this.state.status_index].status)
      ? temp_user_arr[this.state.status_index].status
      : (display.status || 'unknown')
    const sessions = []

    if (display.sessions) {
      sortProgramSessions(display.sessions).forEach((session) => {
        sessions.push(
          <tr key={makeUniqueKey()}>
            <td>{session.type}</td>
            <td>{formatSessionDateLabel(session)}</td>
            <td>{session.start_time}</td>
            <td>{session.end_time}</td>
            <td>{session.location}</td>
          </tr>
        )
      })
    }

    return (
      <div className='parent-registration-card'>
        <div className="parent-registration-card-header">
          <div>
            <div className="parent-registration-kicker">Registration Details</div>
            <h3 className="parent-registration-title">{display.name || display.group_name || 'Program'}</h3>
            <div className="parent-registration-subtitle">
              {display.group_name || display.name || 'Program'} {display.ages ? `| ${display.ages}` : ''} {display.division ? `| ${display.division}` : ''}
            </div>
          </div>
          <div className="parent-registration-status-badge">
            {String(status || 'unknown').toUpperCase()}
          </div>
        </div>

        <div className="parent-registration-meta-grid">
          <div className="parent-registration-meta-item">
            <span>Dates</span>
            <strong>{this.formatDate(display.start_date)} - {this.formatDate(display.end_date)}</strong>
          </div>
          <div className="parent-registration-meta-item">
            <span>Age Group</span>
            <strong>{display.ages || '-'}</strong>
          </div>
          <div className="parent-registration-meta-item">
            <span>Group Name</span>
            <strong>{display.group_name || '-'}</strong>
          </div>
          <div className="parent-registration-meta-item">
            <span>Division</span>
            <strong>{display.division || '-'}</strong>
          </div>
        </div>

        <div className="parent-registration-copy">
          <div className="parent-registration-copy-label">Description</div>
          <div className="parent-registration-copy-body">{display.program_description || 'No description available.'}</div>
        </div>

        <div className="parent-registration-copy">
          <div className="parent-registration-copy-label">Additional Notes</div>
          <div className="parent-registration-copy-body">{display.additional_notes || 'No additional notes.'}</div>
        </div>

        {includeSessions && (
          <div className="parent-registration-sessions">
            <div className="parent-registration-copy-label">Sessions</div>
            {sessions.length > 0 ? (
              <table className='parent-table parent-registration-table'>
                <thead>
                  <tr>
                    <th className="parentPtl-th">Session Type</th>
                    <th className="parentPtl-th">Days</th>
                    <th className="parentPtl-th">Start</th>
                    <th className="parentPtl-th">End</th>
                    <th className="parentPtl-th">Location</th>
                  </tr>
                </thead>
                <tbody>
                  {sessions}
                </tbody>
              </table>
            ) : (
              <div className="parent-portal-empty-inline">No sessions have been scheduled for this registration.</div>
            )}
          </div>
        )}
      </div>
    )
  }

  renderProfileTab = () => {
    const { athletes } = this.state
    const registeredUsers = Array.isArray(athletes) ? athletes : []

    return (
      <div className="parent-portal-section">
        <Row className="parent-portal-row">
          <Col sm={12}>
            <div className="parent-family-list parent-family-list-top">
              <div className="parent-family-card">
                <div className="parent-family-card-header">
                  <div>
                    <div className="parent-family-name">Account Holder</div>
                    <div className="parent-family-meta">{this.state.account_holder_email || 'No email on file'}</div>
                  </div>
                  <div className="parent-family-badge">Primary</div>
                </div>

                <div className="parent-family-details">
                  <div>
                    <span>First Name</span>
                    <FormControl className="opaque-grey" type="text" value={this.state.account_holder_first_name} onChange={(e) => this.handleChange('account_holder_first_name', e)} />
                  </div>
                  <div>
                    <span>Last Name</span>
                    <FormControl className="opaque-grey" type="text" value={this.state.account_holder_last_name} onChange={(e) => this.handleChange('account_holder_last_name', e)} />
                  </div>
                  <div>
                    <span>Email</span>
                    <FormControl className="opaque-grey" type="text" value={this.state.account_holder_email} onChange={(e) => this.handleChange('account_holder_email', e)} />
                  </div>
                  <div>
                    <span>Phone</span>
                    <FormControl className="opaque-grey" type="text" value={this.state.account_holder_phone} onChange={(e) => this.handleChange('account_holder_phone', e)} />
                  </div>
                </div>

                <div className="parent-family-details">
                  <div>
                    <span>Receive marketing emails</span>
                    <Checkbox checked={!this.state.marketing_opt_out} onClick={this.handleMarketingChange} />
                  </div>
                </div>

                <div className="parent-family-programs">
                  <Button className="orange-fill" disabled={!this.isAccountHolderDirty()} onClick={this.handleAccountHolderSubmit}>
                    Save Account Holder
                  </Button>
                </div>
              </div>

              <div className="parent-family-card">
                <div className="parent-family-card-header">
                  <div>
                    <div className="parent-family-name">Secondary Contact</div>
                    <div className="parent-family-meta">{this.state.emergency_contact_email || 'No secondary email on file'}</div>
                  </div>
                  <div className="parent-family-badge">Secondary</div>
                </div>

                <div className="parent-family-details">
                  <div>
                    <span>First Name</span>
                    <FormControl className="opaque-grey" type="text" value={this.state.emergency_contact_first_name || ''} onChange={(e) => this.handleChange('emergency_contact_first_name', e)} />
                  </div>
                  <div>
                    <span>Last Name</span>
                    <FormControl className="opaque-grey" type="text" value={this.state.emergency_contact_last_name || ''} onChange={(e) => this.handleChange('emergency_contact_last_name', e)} />
                  </div>
                  <div>
                    <span>Email</span>
                    <FormControl className="opaque-grey" type="text" value={this.state.emergency_contact_email || ''} onChange={(e) => this.handleChange('emergency_contact_email', e)} />
                  </div>
                  <div>
                    <span>Phone</span>
                    <FormControl className="opaque-grey" type="text" value={this.state.emergency_contact_phone || ''} onChange={(e) => this.handleChange('emergency_contact_phone', e)} />
                  </div>
                </div>

                <div className="parent-family-programs">
                  <Button className="orange-fill" disabled={!this.isAccountHolderDirty()} onClick={this.handleAccountHolderSubmit}>
                    Save Secondary Contact
                  </Button>
                </div>
              </div>
            </div>

            <div className="parent-portal-section-title parent-portal-section-title-spaced">
              Registered Users
            </div>

            {registeredUsers.length > 0 ? (
              registeredUsers.map((athlete) => (
                <AthleteProfile
                  key={athlete._id}
                  data={athlete}
                  patchUpdateMethod={this.handleUpdateSubmit}
                  archiveFromParentPortal={this.handleHideAthleteFromPortal}
                  orgUDFs={this.state.orgUDFs}
                  organization_id={this.state.organization_id}
                  token={this.state.token}
                  athlete_spinner={this.state.athlete_spinner}
                />
              ))
            ) : (
              <div className="parent-portal-empty">No family members were found for this account.</div>
            )}
          </Col>
        </Row>
      </div>
    )
  }

  renderEmailPreferencesTab = () => {
    return null
  }

  renderSelectedRegistrationDetails = () => {
    const registrations = Array.isArray(this.state.registrations) ? this.state.registrations : []
    const selectedRegistration = registrations.find((registration) => registration.key === this.state.selected_registration_key) || registrations[0] || null
    return selectedRegistration
      ? this.displayProgram(selectedRegistration.program_id, false)
      : <div className="parent-portal-empty">No registrations were found for this account yet.</div>
  }

  renderRegistrationsTab = () => {
    const registrations = Array.isArray(this.state.registrations) ? this.state.registrations : []
    const selectedRegistration = registrations.find((registration) => registration.key === this.state.selected_registration_key) || registrations[0] || null

    if (!registrations.length) {
      return <div className="parent-portal-empty">No registrations were found for this account yet.</div>
    }

    return (
      <div className="parent-portal-section">
        <Row className="parent-portal-row parent-registration-layout-row">
          <Col sm={12} lg={12}>
            <div className="parent-registration-details-shell">
              {selectedRegistration ? this.displayProgram(selectedRegistration.program_id) : null}
            </div>
          </Col>
        </Row>
      </div>
    )
  }

  renderConversationsTab = () => {
    const registrations = Array.isArray(this.state.registrations) ? this.state.registrations : []
    const selectedRegistration = registrations.find((registration) => registration.key === this.state.selected_registration_key) || registrations[0] || null
    const messagingConversations = this.getRegistrationConversations(selectedRegistration)
    const selectedConversation = messagingConversations.find((conversation) => conversation.conversation_key === this.state.selected_registration_conversation_key) || messagingConversations[0] || null
    const selectedConversationLabel = selectedConversation ? selectedConversation.label : 'Participants'

    if (!selectedRegistration) {
      return <div className="parent-portal-empty">No registrations were found for this account yet.</div>
    }

    return (
      <div className="parent-portal-section">
        <div className="parent-registration-chat-card">
          <div className="parent-registration-selector-card parent-registration-chat-selector-card">
            <div className="parent-registration-selector-summary">
              <span>Conversation</span>
              <strong>{selectedConversationLabel}</strong>
            </div>
            <FormControl
              className="opaque-grey selector padded"
              id="selected_registration_conversation"
              componentClass="select"
              value={selectedConversation ? selectedConversation.conversation_key : ''}
              onChange={(event) => this.setState({ selected_registration_conversation_key: event.target.value })}
            >
              {messagingConversations.map((conversation) => (
                <option key={conversation.conversation_key} value={conversation.conversation_key}>
                  {conversation.label}
                </option>
              ))}
            </FormControl>
          </div>
          <AthleteMessagesPanel
            athlete={null}
            organizationId={this.state.organization_id}
            token={this.state.token}
            conversationType="group"
            conversationKey={selectedConversation ? selectedConversation.conversation_key : null}
            conversationLabel={selectedConversation ? selectedConversation.label : 'Participants'}
            programId={selectedRegistration.program_id}
            groupName={selectedConversation ? selectedConversation.group_name : null}
            currentUserType="parent"
            visible={!!selectedRegistration}
            className="parent-registration-chat-panel"
            panelTitle="Messaging"
          />
        </div>
      </div>
    )
  }

  renderScheduleTab = () => {
    const allRegistrations = Array.isArray(this.state.registrations) ? this.state.registrations : []
    const selectedRegistration = allRegistrations.find((registration) => registration.key === this.state.selected_registration_key) || allRegistrations[0] || null
    const registrations = selectedRegistration ? [selectedRegistration] : []

    if (!registrations.length) {
      return <div className="parent-portal-empty">No schedule entries were found for this account yet.</div>
    }

    const scheduleEntries = registrations.flatMap((registration) => {
      const program = Array.isArray(this.state.program_map)
        ? this.state.program_map.find((data) => data && data._id && data._id.toString() === registration.program_id.toString())
        : null

      const sessions = program && Array.isArray(program.sessions) ? sortProgramSessions(program.sessions) : []

      return sessions.map((session) => ({
        registration,
        session,
      }))
    })

    if (!scheduleEntries.length) {
      return <div className="parent-portal-empty">No scheduled sessions have been loaded for these registrations.</div>
    }

    return (
      <div className="parent-portal-section">
        <div className="parent-family-list">
          {registrations.map((registration) => {
            const program = Array.isArray(this.state.program_map)
              ? this.state.program_map.find((data) => data && data._id && data._id.toString() === registration.program_id.toString())
              : null
            const sessions = program && Array.isArray(program.sessions) ? sortProgramSessions(program.sessions) : []

            if (!sessions.length) {
              return (
                <div className="parent-registration-card" key={registration.key}>
                  <div className="parent-registration-card-header">
                    <div>
                      <div className="parent-registration-kicker">Schedule</div>
                      <h3 className="parent-registration-title">{registration.program_name}</h3>
                      <div className="parent-registration-subtitle">{registration.athlete_name}</div>
                    </div>
                    <div className="parent-registration-status-badge">No Sessions</div>
                  </div>
                  <div className="parent-portal-empty-inline">No sessions have been scheduled for this registration.</div>
                </div>
              )
            }

            return (
              <div className="parent-registration-card" key={registration.key}>
                <div className="parent-registration-card-header">
                  <div>
                    <div className="parent-registration-kicker">Schedule</div>
                    <h3 className="parent-registration-title">{registration.program_name}</h3>
                    <div className="parent-registration-subtitle">{registration.athlete_name}</div>
                  </div>
                  <div className="parent-registration-status-badge">{String(registration.status || 'unknown').toUpperCase()}</div>
                </div>

                <div className="parent-registration-copy">
                  <div className="parent-registration-copy-label">Sessions</div>
                  <table className='parent-table parent-registration-table'>
                    <thead>
                      <tr>
                        <th className="parentPtl-th">Session Type</th>
                        <th className="parentPtl-th">Days</th>
                        <th className="parentPtl-th">Start</th>
                        <th className="parentPtl-th">End</th>
                        <th className="parentPtl-th">Location</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sessions.map((session) => (
                        <tr key={makeUniqueKey()}>
                          <td>{session.type}</td>
                          <td>{formatSessionDateLabel(session)}</td>
                          <td>{session.start_time}</td>
                          <td>{session.end_time}</td>
                          <td>{session.location}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  render() {
    if (!this.state.haveData) {
      return (<div className="full-page"><div className="loader cent"></div></div>)
    }

    const { activeTab } = this.state

    return (
      <div className="full-page">
        <HamburgerNavbar hideProfileSettings showFamily />

        <div className="body-wrapper">
          <div className="parent-portal-shell">
            <div className="dashboard-header-shell">
              <div className="programs-page-hero parent-portal-page-hero">
              <div className="programs-page-kicker">Parent Portal</div>
              {this.renderTeamSelector()}
              </div>
            </div>

            <div className="organization-tabs-wrapper parent-portal-tabs">
              {!this.props.standaloneTab && (
                <Tabs
                  defaultActiveKey={activeTab}
                  onSelect={this.handleTabSelect}
                  id="parent-portal-tabs"
                  animation={false}
                >
                  <Tab eventKey="registrations" title="Program Details" />
                  <Tab eventKey="conversations" title="Team Chat" />
                  <Tab eventKey="schedule" title="Schedule" />
                </Tabs>
              )}

              <div className="dashboard-box organization-tab-panel parent-portal-panel">
                <div className="organization-tab-content">
                  {activeTab === 'family' && this.renderProfileTab()}
                  {activeTab === 'registrations' && this.renderRegistrationsTab()}
                  {activeTab === 'conversations' && this.renderConversationsTab()}
                  {activeTab === 'schedule' && this.renderScheduleTab()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ParentPortal;
